"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = __importDefault(require("../../components/message/Message"));
const OverlayStyled_1 = __importDefault(require("./OverlayStyled"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const SquareButton_1 = __importDefault(require("../squareButton/SquareButton"));
const epic_tracking_1 = __importDefault(require("epic-tracking"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const route_1 = require("../../utils/route");
const query_string_1 = __importDefault(require("query-string"));
const Overlay = ({ image, close, upperCaseCode, handleSubmit, link }) => {
    const goToRedeem = react_1.default.useCallback(() => {
        epic_tracking_1.default.trackEvent('Interaction', {
            interactionType: 'click',
            eventCategory: 'RedeemCode',
            eventAction: 'redirectTo-vbuckscard'
        });
        const [, linkQueryString] = link.split('?');
        const linkQuery = query_string_1.default.parse(linkQueryString || '');
        window_or_global_1.default.location.href = route_1.getVbucksRedirectURL(window_or_global_1.default.location, Object.assign(Object.assign({}, linkQuery), { code: upperCaseCode }));
    }, [upperCaseCode, link]);
    return (react_1.default.createElement(OverlayStyled_1.default, { className: "overlay" },
        react_1.default.createElement("div", { className: "overlay-wrapper" },
            react_1.default.createElement("span", { className: "overlay-close", onClick: close, role: "presentation" }),
            react_1.default.createElement("div", { className: "overlay-content" },
                react_1.default.createElement("div", { className: "overlay-content-wrapper" },
                    react_1.default.createElement("div", { className: "overlay-content-block" },
                        react_1.default.createElement("h1", null,
                            react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.validate.couldBePosa.message" })),
                        react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.validate.couldBePosa.needHelp" })),
                    react_1.default.createElement("div", { className: "overlay-content-block" },
                        react_1.default.createElement("img", { alt: "V-Bucks Card", src: image }))),
                react_1.default.createElement("div", { className: "buttons-container" },
                    react_1.default.createElement(SquareButton_1.default, { handleClick: goToRedeem, config: { buttonStyle: 'btn-primary', width: '240px', centered: true } },
                        react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.validate.couldBePosa.cta" })),
                    react_1.default.createElement(SquareButton_1.default, { handleClick: handleSubmit, config: { buttonStyle: 'btn-default', width: '240px', centered: true } },
                        react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.validate.couldBePosa.continue" })))))));
};
Overlay.propTypes = {
    close: prop_types_1.default.func,
    handleSubmit: prop_types_1.default.func,
    image: prop_types_1.default.string,
    upperCaseCode: prop_types_1.default.string,
    link: prop_types_1.default.string
};
exports.default = Overlay;
//# sourceMappingURL=Overlay.js.map